var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5459 17.9545C19.7572 18.1658 19.876 18.4525 19.876 18.7513C19.876 19.0502 19.7572 19.3369 19.5459 19.5482C19.3346 19.7596 19.0479 19.8783 18.749 19.8783C18.4501 19.8783 18.1635 19.7596 17.9521 19.5482L12 13.5942L6.0459 19.5463C5.83455 19.7577 5.54791 19.8764 5.24902 19.8764C4.95014 19.8764 4.66349 19.7577 4.45215 19.5463C4.2408 19.335 4.12207 19.0484 4.12207 18.7495C4.12207 18.4506 4.2408 18.1639 4.45215 17.9526L10.4062 12.0004L4.45402 6.04635C4.24268 5.835 4.12395 5.54836 4.12395 5.24947C4.12395 4.95058 4.24268 4.66394 4.45402 4.4526C4.66537 4.24125 4.95201 4.12252 5.2509 4.12252C5.54978 4.12252 5.83643 4.24125 6.04777 4.4526L12 10.4067L17.954 4.45166C18.1654 4.24031 18.452 4.12158 18.7509 4.12158C19.0498 4.12158 19.3364 4.24031 19.5478 4.45166C19.7591 4.663 19.8778 4.94965 19.8778 5.24853C19.8778 5.54742 19.7591 5.83406 19.5478 6.04541L13.5937 12.0004L19.5459 17.9545Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.f1398a918d707ec2368ab9f0d455bbd4.svg";
export { ForwardRef as ReactComponent };